import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ProfileSkeleton = () => {
  const styles = {
    top: {
      marginTop: 30,
      marginBottom: 30
    },
    item: {
      borderRadius: 30
    }
  };
  return (
    <>
      <Skeleton count={1} height={270} borderRadius={15} style={styles.top} />
      <Skeleton count={1} height={305} borderRadius={15} />
    </>
  );
};

export default ProfileSkeleton;
